<template>
	<div id="subscription">
		<SubpageHeader
			@on-back="actionBack"
		>
			月額/半年/年間会員
		</SubpageHeader>
		<div class="container-block">
			<div class="container">
				<div class="centerblock">
					<div class="history_loading" v-if="isRunningMonthlyLog">
						<LoadingMark>
						</LoadingMark>
					</div>

					<div v-if="!isRunningMonthlyLog" class="subPayment paymentCredit">
						<ModalGmo
							v-if="showModalGmo"
							:contents-name="gmoContentsName()"
							:contents-money="gmoContentsMoney()"
							:val-money="gmoValMoney()"
							:enable-point="false"
							@close-modal="closeGmoModal"
							@buy-gmo="doSubscription"
							
						></ModalGmo>
						
						<div v-if="monthlyStatus.status">
							<dl class="subsc_status">
								<dt>{{textMonthlyKindName}}</dt>
								<dd>{{textMonthlyLimit}}まで有効</dd>
							</dl>
							<div v-if="isSubscMonthly">
								<div v-if="autoMonthlyFlag" class="subsc_next">
									次回の月額利用料金は {{textMonthlyNextPayment}} に自動で決済されます。
								</div>
								<div v-else class="subsc_autocancel">
									月額会員の自動継続を停止しました。<br />
									有効期限日までは施設をご利用できます。
								</div>
							</div>
						</div>
						<div v-else class="subsc_status">
							月額/半年/年間会員ではありません
						</div>

						<div v-if="!monthlyStatus.status || autoMonthlyFlag">
							<div v-if="monthlyStatus.status" class="monthlybtn">
								<div class="one">
									<button class="btn btn-primary" @click.prevent="clickCancelMonthly">月額利用の継続を<br />停止する</button>								
								</div>
							</div>
							<div v-else>
								<div class="monthly_caution">
									必ず<a href="https://connect.universal-field.com/rule.html" target="_blank">利用規約</a>を確認いただき、ご同意の上、お申込みください									
								</div>

								<div class="subtitle">月額会員</div>
								<div class="monthlybtn">
									<div v-for="info in listMonthly" class="one" :key="info.id">
										<button class="btn btn-primary" @click.prevent="clickBuyMonthly(info)">{{getContentsName(info)}}で入会<br />{{getContentsMoney(info)}}</button>
									</div>
								</div>

								<div class="subsc_description">
									<ul>
										<li v-for="desc, index in aryPlanDesc" :key="index">{{desc}}</li>
									</ul>
								</div>

								<div class="subtitle">半年会員</div>
								<div class="monthlybtn">
									<div v-for="info in listHalfAnnual" class="one" :key="info.id">
										<button class="btn btn-primary" @click.prevent="clickBuyHalfAnnual(info)">{{getContentsName(info)}}で入会<br />{{getContentsMoney(info)}}</button>
									</div>
								</div>
								<div class="subtitle">年間会員</div>
								<div class="monthlybtn">
									<div v-for="info in listAnnual" class="one" :key="info.id">
										<button class="btn btn-primary" @click.prevent="clickBuyAnnual(info)">{{getContentsName(info)}}で入会<br />{{getContentsMoney(info)}}</button>
									</div>
								</div>
							</div>
						</div>
						
						<div v-if="monthlyStatus && isContinuePayment">
							有効期限のひと月前より、会員継続の申し込みを行うことができます。<br />
							継続をご希望の方は、下記より決済をお願いいたします。
							<div class="subtitle">半年会員</div>
							<div class="monthlybtn">
								<div v-for="info in listHalfAnnual" class="one" :key="info.id">
									<button class="btn btn-primary" @click.prevent="clickBuyHalfAnnual(info)">{{getContentsName(info)}}で継続<br />{{getContentsMoney(info)}}</button>
								</div>
							</div>
							<div class="subtitle">年間会員</div>
							<div class="monthlybtn">
								<div v-for="info in listAnnual" class="one" :key="info.id">
									<button class="btn btn-primary" @click.prevent="clickBuyAnnual(info)">{{getContentsName(info)}}で継続<br />{{getContentsMoney(info)}}</button>
								</div>
							</div>
						</div>

					</div>
					<div class="subsc_description">
						<ul>
							<li v-for="desc, index in aryPlanDesc" :key="index">{{desc}}</li>
						</ul>
					</div>

					<div class="history">
						<HeaderCaption>利用状況</HeaderCaption>
						<div class="history_loading" v-if="isRunningMonthlyLog">
							<LoadingMark>
							</LoadingMark>
						</div>
						<div v-if="!isRunningMonthlyLog" class="history_list">
							<table v-if="existMonthlyLog" class="history_table">
								<tbody>
									<tr v-for="history, index in listRunningMonthlyLog" :key="index">
										<td>{{historyDate(history)}}</td>
										<td>{{historyContent(history)}}</td>
									</tr>
								</tbody>
							</table>
							<div v-else class="notrslog">
								利用状況はありません。
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import SubpageHeader from '@/components/SubpageHeader';
	import ModalGmo from '@/components/ModalGmo';
	import HeaderCaption from '@/components/common/HeaderCaption';
	import LoadingMark from '@/components/LoadingMark';
	import {ymdToText, ymdToDate, dateToText, addFigure} from '@/lib/formatter';

	export default {
		components: {
			SubpageHeader,
			ModalGmo,
			HeaderCaption,
			LoadingMark
			//ApiResponse
		},
		props: {
		},
		data() {
			return {
				// 選択された月額情報
				selectedSubsc: null,
				// GMO購入
				showModalGmo: false,
				typeModalGmo: 0,
				// 複数回同時購入禁止
				flagClickedBuy: false,
				aryPlanDesc: [
					'Ｕ２２ … 通常プラン',
					'レギュラー … 通常プラン',
					'ブロンズ… 通常＋タオル',
					'シルバー… 通常＋コーヒーサブスク(1日1杯)',
					'ゴールド… 通常＋全メニューサブスク(1日1杯)',
					'プラチナ… 通常＋タオル＋全メニューサブスク(1日1杯)'
				]
			}
		},
		computed: {
			creditCno() {
				return this.$store.getters['gmoStore/getCreditCno'];
			},
			creditSno() {
				return this.$store.getters['gmoStore/getCreditSno'];
			},
			creditLimitYear() {
				return this.$store.getters['gmoStore/getCreditLimitYear'];
			},
			creditLimitMonth() {
				return this.$store.getters['gmoStore/getCreditLimitMonth'];
			},
			// 月額種類
			listMonthly() {
				return this.$store.getters['commonStore/getListMonthly'];
			},
			// 半年種類
			listHalfAnnual() {
				return this.$store.getters['commonStore/getListHalfAnnual'];
			},
			// 年額種類
			listAnnual() {
				return this.$store.getters['commonStore/getListAnnual'];
			},
			// ランステ月額会員利用状況取得中
			isRunningMonthlyLog() {
				return this.$store.getters['commonStore/getRunningMonthlyLog'];
			},
			// ランステ月額会員利用状況リスト
			listRunningMonthlyLog() {
				const runst_list = this.$store.getters['commonStore/getListMonthlyLog'];
				return runst_list;
			},
			// サブスクは月額会員か
			isSubscMonthly() {
				return this.$store.getters['commonStore/isSubscMonthly'];
			},
			existMonthlyLog() {
				const runst_list = this.$store.getters['commonStore/getListMonthlyLog'];
				return runst_list && Array.isArray(runst_list) && runst_list.length;
			},
			monthlyStatus() {
				return this.$store.getters['commonStore/getMonthlyStatus'];
			},
			textMonthlyKindName() {
				const monthly = this.monthlyStatus;
				if(monthly.kind_info && monthly.kind_info.name) return monthly.kind_info.name;
				return '';
			},
			// 月額有効期限を文字列で取得する
			textMonthlyLimit() {
				const monthly = this.monthlyStatus;
				if(monthly.limit) return ymdToText(monthly.limit);
				return '';
			},
			// 次回の月額決済日
			textMonthlyNextPayment() {
				// 有効期限の前日
				const monthly = this.monthlyStatus;
				const date = ymdToDate(monthly.limit);
				date.setDate(date.getDate()-1);
				return dateToText(date);
			},
			// ランステ月額自動継続フラグ
			autoMonthlyFlag() {
				return this.$store.getters['commonStore/getAutoMonthlyFlag'];
			},
			// 半年年間会員の継続表示
			isContinuePayment() {
				const monthly = this.monthlyStatus;
				return monthly.continue_payment ? true : false;
			}
		},
		methods: {
			gmoContentsName() {
				return this.getContentsName(this.selectedSubsc);
			},
			gmoContentsMoney() {
				return this.getContentsMoney(this.selectedSubsc);
			},
			gmoValMoney() {
				return this.selectedSubsc.money;
			},
			getContentsName(info) {
				return info.name;
			},
			getContentsMoney(info) {
				return addFigure(info.money)+'円';
			},
			actionBack() {
				this.$router.push('/top');
			},
			clickCancelMonthly() {
				let msg = '月額利用継続を停止しますか？<br />';
				msg += '停止しても '+this.textMonthlyLimit+' までは施設のご利用は行えます。'
				this.$dialog.confirm({
					title: '確認',
					body: msg
				},{
					okText: '月額継続を停止する',
					cancelText: 'キャンセル',
					html: true
				})
				.then(async () => {
					this.$store.commit('commonStore/setLoading', true);
					const result = await this.$store.dispatch('gmoStore/cancelSubscription');
					this.$store.commit('commonStore/setLoading', false);

					if(result) {
						if(result.error) {
							this.$dialog.alert(result.error,{okText: 'OK'});
						} else if(result.payload) {
							if(result.payload.ErrCode) {
								const text = result.payload.ErrCode+":"+result.payload.ErrInfo+"\n"+result.payload.ErrMsg;
								this.$dialog.alert(text,{okText: 'OK'});
							}
						}
					}
				})
				.catch(() => {
					this.$store.commit('commonStore/setLoading', false);
				});
			},
			clickBuyMonthly(info) {
				this.selectedSubsc = info;
				this.showModalGmo = true;
			},
			clickBuyHalfAnnual(info) {
				this.selectedSubsc = info;
				this.showModalGmo = true;
			},
			clickBuyAnnual(info) {
				this.selectedSubsc = info;
				this.showModalGmo = true;
			},
			closeGmoModal() {
				this.$store.commit('gmoStore/setCreditCno', '');
				this.$store.commit('gmoStore/setCreditSno', '');
				this.$store.commit('gmoStore/setCreditLimitYear', '');
				this.$store.commit('gmoStore/setCreditLimitMonth', '');

				this.showModalGmo = false;
			},
			async doSubscription() {
				if(!this.selectedSubsc) return;
				if(this.flagClickedBuy) return;
				this.flagClickedBuy = true;
				const errors = await this.$store.dispatch('gmoStore/validateGmoInput');
				if(errors.length) {
					this.$dialog.alert(errors.join('\n'),{okText: 'OK'});
					this.flagClickedBuy = false;
					return;
				}
				
				const option = {...this.selectedSubsc};
				option.continuePayment = this.isContinuePayment;
				
				const result = await this.$store.dispatch('gmoStore/runSubscription', option);
				if(result) {
					if(result.error) {
						this.$dialog.alert(result.error.msg,{okText: 'OK'});
					} else if(result.payload) {
						if(result.payload.ErrCode) {
							const text = result.payload.ErrCode+":"+result.payload.ErrInfo+"\n"+result.payload.ErrMsg;
							this.$dialog.alert(text,{okText: 'OK'});
						} else if(result.payload.OrderID) {
							let text = '決済成功:'+result.payload.OrderID;
							if(result.payload.RecurringErrInfo) {
								text += "\n(自動継続の登録に失敗しました。["+result.payload.RecurringErrInfo+":"+result.payload.RecurringErrMsg+"])";
							}
							this.$dialog.alert(text,{okText: 'OK'});
							this.closeGmoModal();
							this.$store.dispatch('commonStore/apiMonthlyLog')
						}
					}
				}
				this.flagClickedBuy = false;
			},
			historyDate(history) {
				return ymdToText(history.ymd);
			},
			historyContent(history) {
				return history.desc;
			},
		},
		mounted() {
			this.$store.dispatch('commonStore/apiMonthlyLog').then(() => {
			});
		}
	};
</script>

<style lang="scss" scoped>
	#subscription {
		margin: 0 auto;
		padding: 0;
		height: 100vh;
		
		.container-block {	
			padding: 8px;
			.container {
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				.centerblock {
					dl.subsc_status {
						display: flex;
						justify-content: center;
						align-items: center;

						border-bottom: solid 1px #333;
						font-size: 16px;
						line-height: 1.4;
						
						dt {
							width: 40%;
							margin: 0;
							text-align: left;
							padding: 0 0 0 1em;
							white-space: nowrap;
						}
						dd {
							width: 60%;
							margin: 0;
							text-align: right;
							padding: 0 1em 0 0;
							white-space: nowrap;
						}
					}
					.subsc_next {
						font-size: 12px;
						line-height: 1.7;
					}
					.subsc_autocancel {
						font-size: 14px;
						line-height: 1.7;
					}

					.batchPayment {
						margin-top: 2em;
					}
					.searchBulkPayment {
						margin-top: 2em;
					}
					.subtitle {
						margin-top: 1em;
						line-height: 2;
						border-bottom: solid 1px #ccc;
						padding-left: 0.5em;
					}
					.monthlybtn {
						margin-top: 0.5em;
						display: flex;
						justify-content: center;
						align-items: center;
						flex-wrap: wrap;
						.one {
							width: 50%;
							text-align: center;
							padding: 0 4px 8px;
							button {
								width: 100%;
								max-width: 180px;
								padding: 8px;
								white-space: nowrap;
							}
						}
					}
					.monthly_caution {
						margin-top: 1em;
						color: #a00;
						padding: 8px 0 16px;
					}

					.subsc_description {
						display: flex;
						justify-content: center;
						ul {
							margin: 0;
							padding: 0;
							list-style-type: none;
							width: auto;
							li {
								width: auto;
								border-bottom: dotted 1px #aaa;
								margin-top: 8px;
							}
						}
					}
					.history {
						.history_list {
							padding: 8px;
						}
						.history_loading {
							width: 32px;
							height: 32px;
							margin: 0 auto;
						}
						table {
							font-size: 12px;
							width: auto;
							&.history_table {
								td:nth-child(1) {
									text-align: center;
								}
							}
						}
						.notrslog {
							font-size: 14px;
							line-height: 1.7;
						}
					}

				}
			}
		}
	}
</style>
